import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TablePagination,
  InputAdornment,
} from "@mui/material";
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase"; // <-- your firebase config file
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import Payroleheader from './Payroleheader';

function Staffcategory() {
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  // Search + Pagination
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Fetch categories
  const fetchCategories = async () => {
    setLoading(true);
    const snapshot = await getDocs(collection(db, "staffcategories"));
    setCategories(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    setLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Add or Update
  const handleSave = async () => {
    if (!categoryName.trim()) return;

    if (editId) {
      const ref = doc(db, "staffcategories", editId);
      await updateDoc(ref, { name: categoryName.trim() });
    } else {
      await addDoc(collection(db, "staffcategories"), {
        name: categoryName.trim(),
        createdAt: new Date(),
      });
    }
    setCategoryName("");
    setEditId(null);
    setOpen(false);
    fetchCategories();
  };

  // Delete
  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "staffcategories", id));
    fetchCategories();
  };

  // Edit
  const handleEdit = (cat) => {
    setCategoryName(cat.name);
    setEditId(cat.id);
    setOpen(true);
  };

  // Pagination + Search filter
  const filteredData = categories.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box p={3}>
      <Payroleheader />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5" fontWeight="bold">
          कर्मचारी श्रेणी
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            setEditId(null);
            setCategoryName("");
            setOpen(true);
          }}
        >
          श्रेणी जोडा
        </Button>
      </Box>

      {/* Search Box */}
      <TextField
        placeholder="श्रेणी शोधा..."
        size="small"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      {/* Category Table */}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>अनुक्रमांक</TableCell>
            <TableCell>श्रेणीचे नाव</TableCell>
            <TableCell align="right">क्रिया</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={3}>लोड होत आहे...</TableCell>
            </TableRow>
          ) : paginatedData.length > 0 ? (
            paginatedData.map((cat, index) => (
              <TableRow key={cat.id}>
                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                <TableCell>{cat.name}</TableCell>
                <TableCell align="right">
                  <IconButton color="primary" onClick={() => handleEdit(cat)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDelete(cat.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3}>कोणतीही श्रेणी सापडली नाही</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={filteredData.length}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
      />

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{editId ? "श्रेणी संपादित करा" : "श्रेणी जोडा"}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            label="श्रेणीचे नाव"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="error">
            रद्द करा
          </Button>
          <Button onClick={handleSave} variant="contained">
            {editId ? "अपडेट करा" : "जतन करा"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>

  );
}

export default Staffcategory;
